import React from "react";
import loading from "../assets/loading.svg";

const Loading = () => (
  <div className="spinner flex h-screen justify-center items-center">
    <img src={loading} alt="Loading" className="m-auto" />
  </div>
);

export default Loading;
